import type { ReactNode } from 'react'

import { lighten } from 'polished'
import styled, { css } from 'styled-components'

import { Link as LinkBase } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	type?: keyof Omit<typeof helpers.color, 'status'>
	label: ReactNode
}

export const solidStyling = css<Props>`
	display: block;
	color: ${helpers.color.textContrast};
	background-color: ${({ theme }) => theme.color.primary};
	-webkit-font-smoothing: antialiased;
	font-weight: 500;
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.base};
	width: ${({ fullWidth }) => fullWidth && '100%'};
	border-radius: 40px;
	min-width: 140px;
	height: 40px;
	padding: 9px 24px;
	transition: color 0.2s, background-color 0.2s;
	white-space: nowrap;
	text-align: center;
	margin: 0;
	text-decoration: none;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => lighten(0.1, theme.color.primary)};
		text-decoration: none;
		color: ${helpers.color.textContrast};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		color: ${helpers.color.disabled};
	}
`

export const LinkSolid = styled(LinkBase).attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${solidStyling};
`
